import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

import Input from "../app/Input";
import Button from "../app/Button";
import analytics from "src/helpers/analytics";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";

interface PatientNameProps {
  title: string;
  description: string;
  value?: string;
  onBack: () => void;
  onNext: (name: string) => void;
  support_program_key?: string;
}

const PatientName: React.FC<PatientNameProps> = ({
  title,
  description,
  value,
  onBack,
  onNext,
  support_program_key,
}) => {
  const [name, setName] = useState(value || "");
  const [error, setError] = useState("");

  useEffect(() => {
    analytics.pageView(SCREEN_NAMES.NAME_CAPTURE_SCREEN);
  }, []);

  const handleContinue = () => {
    if (!name.trim()) {
      setError("Patient's name is required.");
      return;
    }

    // Event: PATIENT_NAME_CAPTURED
    analytics.trackEvent(EVENT_NAMES.NAME_CAPTURED, {
      patient_name: name.trim(),
      screen_name: SCREEN_NAMES.NAME_CAPTURE_SCREEN,
      support_program_key: support_program_key,
    });
    onNext(name.trim());
  };

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="p-4 flex-1 min-h-0 overflow-y-auto">
        <button
          className="flex items-center gap-1 px-4 py-2 -ml-4"
          onClick={onBack}
        >
          <ArrowLeft className="w-4 h-4 text-gray-500" />
          <p className="text-sm text-gray-500">Back</p>
        </button>

        <div className="my-4">
          <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-2">
            {title}
          </h1>
          <p className="text-[var(--text-secondary)]">{description}</p>
        </div>

        <Input
          name="patient_name"
          type="text"
          label="Full Name"
          placeholder="Enter full name"
          value={name}
          onChange={(e) => {
            const value = e.target.value;
            setName(value);
            if (/^[A-Za-z ]*$/.test(value)) {
              setError("");
            } else {
              setError("Please enter a valid name.");
            }
          }}
          error={!!error}
          helperText={error}
          fullWidth
        />
      </div>

      <div className="bg-white border-t border-gray-200 p-4 mt-auto">
        <Button
          fullWidth
          onClick={handleContinue}
          disabled={!name.trim() || !!error}
        >
          <span className="flex items-center gap-2">
            Continue
            <ArrowRight className="w-4 h-4" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default PatientName;
